// Module
var code = "<template>\n    <div ref=\"control\"></div>\n</template>";
// Exports
export default code;